/**
 * `/instalar` — instalar Faktelio en el ordenador sin tener cuenta todavía
 * (`OD-0065`, ampliación del 2026-10-25: «que se pueda instalar directamente
 * desde faktelio.com, en la página principal»).
 *
 * El botón no puede estar en faktelio.com: el navegador solo instala el origen
 * de la página desde la que se pulsa, y desde el sitio público instalaría el
 * sitio público. Así que la portada enlaza aquí y el botón vive en
 * app.faktelio.com.
 *
 * Al instalar, la ventana nueva abre `start_url` (`/`), que sin sesión es la
 * entrada: el alta se hace desde ahí, como siempre. Lo único que cambia es el
 * correo de confirmación, que el sistema abre en el navegador y no en la
 * aplicación, y por eso se avisa antes.
 */
import { t } from "../i18n/es";
import { Boton, Tarjeta } from "../ui/primitivas";
import { InstalarAplicacion } from "./InstalarAplicacion";

export function PantallaInstalar({ onRegistro, onEntrar }: { onRegistro: () => void; onEntrar: () => void }) {
  const c = t.instalar;
  return (
    <Tarjeta titulo={c.titulo}>
      <InstalarAplicacion titulo={null} variante="principal" />
      <section aria-labelledby="titulo-despues">
        <h3 id="titulo-despues" className="subtitulo">
          {c.despuesTitulo}
        </h3>
        <ol className="pasos-instalar">
          {c.despues.map((paso) => (
            <li key={paso}>{paso}</li>
          ))}
        </ol>
      </section>
      <p className="ayuda-neutra">{c.sinInstalar}</p>
      <div className="acciones-en-linea">
        <Boton variante="secundario" onClick={onRegistro}>
          {c.crearEnNavegador}
        </Boton>
        <Boton variante="terciario" onClick={onEntrar}>
          {c.yaTengoCuenta}
        </Boton>
      </div>
    </Tarjeta>
  );
}
